export var TICK_TYPE;
(function (TICK_TYPE) {
    TICK_TYPE["CHECKBOX"] = "checkbox";
    TICK_TYPE["RADIO"] = "radio";
    TICK_TYPE["EXCLUSIVE_CHECKBOX"] = "exclusive-checkbox";
})(TICK_TYPE || (TICK_TYPE = {}));
//# sourceMappingURL=constants.js.map